export default {
	activeLabel: "Active",
	futureLabel: "Future",
	archivedLabel: "Archived",
	unknownLabel: "?",
};
